import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import Copyright from './components/stateless/Copyright';
import UpArrow from './components/stateless/UpArrow';
import VideoLoop from './components/stateless/player/VideoLoop';
import VideoSimple from './components/stateless/player/VideoSimple';

import Events from './components/statefull/Events';
import Team from './components/statefull/Team';
import ContactForm from './components/statefull/Form';
/* import BtnScrollTo from './components/stateless/BtnScrollTo'; */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);


const copyright = ReactDOM.createRoot(document.getElementById('copyright'));
copyright.render(

    <Copyright />

);

const divPlayer1 = document.getElementById('player1');
const videoDemoDispaly = ReactDOM.createRoot(divPlayer1);
videoDemoDispaly.render(

    <VideoLoop
        src={divPlayer1.getAttribute('src')}
        className={divPlayer1.getAttribute('className')}
        playsinline={divPlayer1.getAttribute('playsinline')}
        autoplay={divPlayer1.getAttribute('autoplay')}
        muted={divPlayer1.getAttribute('muted')}
        loop={divPlayer1.getAttribute('loop')}
        type={divPlayer1.getAttribute('type')} />

);

const divPlayer2 = document.getElementById('player2');
const videoPlayer2 = ReactDOM.createRoot(divPlayer2);
videoPlayer2.render(

    <VideoSimple
        src={divPlayer2.getAttribute('src')}
        className={divPlayer2.getAttribute('className')}
        playsinline={divPlayer2.getAttribute('playsinline')}
        autoplay={divPlayer2.getAttribute('autoplay')}
        muted={divPlayer2.getAttribute('muted')}
        loop={divPlayer2.getAttribute('loop')}
        type={divPlayer2.getAttribute('type')} />

);

const upBtn = ReactDOM.createRoot(document.getElementById('upbtn'));
upBtn.render(

    <UpArrow />

);


const events = ReactDOM.createRoot(document.getElementById('history'));
events.render(

    <Events />

);

const contactForm = ReactDOM.createRoot(document.getElementById('contact-form'));
contactForm.render(

    <ContactForm />

);


const members = ReactDOM.createRoot(document.getElementById('team'));
members.render(

    <Team />

);





